import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import {filter, isEqual} from 'lodash';
import {I18n} from 'react-redux-i18n';
import ReactGA from 'react-ga';
import AutoCompleteInput from '../../Form/AutoCompleteInput';
import Chips from '../../components/Chips';
import DatePickerChip from './DatePickerChip';

export default class ChipsFilter extends React.Component {
  static defaultProps = {
    chipsFilter: [],
    isMobile: true
  }
  state = {
    focused: false,
    over: false
  }
  fetchTimer = null;

  handleOnFetchAutocomplete = value => {
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }

    this.fetchTimer = window.setTimeout(() => {
      this.props.searchDriverVehicle({text: value});
      this.fetchTimer = null;
    }, 550);
  }


  handleOnSelectedAutocomplete = (event, {suggestion}) => {
    if (suggestion.type === 'vehicle') {
      this.addTerms('vehicle', suggestion.name, suggestion.name, true, true);
    } else if (suggestion.type === 'driver') {
      this.addTerms('driver', suggestion.id, `${suggestion.name} (${suggestion.number})`, true, true);
    }

    ReactGA.event({
      category: 'Library Filter',
      action: suggestion.type === 'driver' ? 'Driver Name' : 'Vehicle Number',
      label: 'Filter Chips'
    });
  }

  removeTerms = (term, terms) => {
    if (terms.length > 0) {
      return terms.filter(o => o.value != term);
    }

    return terms;
  }

  addTerms = (_term, value, label, isUnique) => {
    let {chipsFilter} = this.props;
    if (isUnique) {
      chipsFilter = this.removeTerms(value, chipsFilter);
    }

    const term = {
      name: _term,
      value,
      label
    };

    chipsFilter = [...chipsFilter, term];

    this.props.updateChipFilter(chipsFilter);
  }

  onMouseOver = () => this.setState({over: true});
  onMouseOut = () => this.setState({over: false});
  onBlur = () => this.setState({focused: false});
  onFocus = () => this.setState({focused: true});

  handleOnRemoveChip = (event, chip) => {
    let {chipsFilter} = this.props;
    chipsFilter = filter(chipsFilter, item => !isEqual(item, chip));
    this.props.updateChipFilter(chipsFilter);

    ReactGA.event({
      category: 'Library Filter',
      action: 'Remove Chip',
      label: 'Filter Chips'
    });
  }

  chipsFilter() {
    if (this.props.isMobile) {
      return (
        <div>
          <ListItem>
            <Chips
              list={this.props.chipsFilter}
              onRemove={this.handleOnRemoveChip}
              id="filterVehicleDriverResult"
            />
          </ListItem>
          <ListItem className="bringontop">
            <AutoCompleteInput
              placeholder={I18n.t('filter.VehicleOrDriver.placeholder')}
              list={this.props.driversVehiclesList}
              onSelect={this.handleOnSelectedAutocomplete}
              onFetchRequested={this.handleOnFetchAutocomplete}
              isLoading={this.props.isLoading}
              id="filterVehicleDriver"
            />
          </ListItem>
        </div>
      );
    }
    let chipClasses = ['desktopfields__chipscont'];
    chipClasses = chipClasses.join(' ');
    return (
      <ListItem className="bringontop desktopfields__mainsearch">
        <div className={chipClasses}>
          <DatePickerChip
            startTime={this.props.startTime}
            endTime={this.props.endTime}
            sortBy={this.props.sortBy}
            handleOnDateApply={this.props.handleOnDateApply}
            showButton={true}
            additionalClass={this.props.additionalClass}
          />
          <Chips
            list={this.props.chipsFilter}
            onRemove={this.handleOnRemoveChip}
            id="filterVehicleDriverResult"
          />
        </div>
      </ListItem>
    );
  }

  render() {
    return (
      <div className="dtcontainer" style={{width: 'auto'}}>
        {this.chipsFilter()}
      </div>
    );
  }
}
